import {
  GET_ALL_BATCHES,
  GET_BATCH,
  GET_SCHOOL_BATCHES,
  GET_CURRENT_BATCH,
  GET_ALL_CLONED_BATCHES,
} from 'actions/admin/batches';

const initialState = {
  batchData: {
    content: [],
  },
  batch: {},
  batchList: [],
  currentBatch: {},
  cloneBatchList: [],
};

export default function batches(state = initialState, action = {}) {
  switch (action.type) {
    case GET_ALL_BATCHES:
      return { ...state, batchData: action.batchData };
    case GET_BATCH:
      return { ...state, batch: action.batch };
    case GET_SCHOOL_BATCHES:
      return { ...state, batchList: action.batches };
    case GET_CURRENT_BATCH:
      return { ...state, currentBatch: action.batchData };
    case GET_ALL_CLONED_BATCHES: {
      return {
        ...state,
        cloneBatchList: action?.cloneBatchList,
      };
    }
    default:
      return state;
  }
}
